import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 🌎 Global Variables

Global variables are user-defined key-value pairs scoped at the **workspace level**. They are accessible throughout the workspace — across **all collections, requests, and flows**. These variables provide a convenient way to define values that need to be shared consistently across the entire project.

They are especially useful for defining values that are not tied to a specific environment or collection — such as app-wide settings, common tokens, fallback URLs, or constants.

Like all variables in HawkClient, Global Variables can be referenced using double curly braces syntax: **{{variableName}}**. This makes your request URLs, headers, and body payloads more dynamic and maintainable.

**Example use case:**  
If your application communicates with multiple services, and one of them has a static utility endpoint like **https://utils.api.example.com**, you can define a global variable **utilsBaseUrl** with that value. Then, in your requests, you can use: **{{utilsBaseUrl}}/status**, making it easy to update in one place if it ever changes.

**Storage:**  
Global variables are stored inside your workspace folder, under the **variables** directory, in a file named **globalVariable.json**. This makes them easy to version control with Git and collaborate across teams.

---

![Global Variables](/docs/globalVariables.png)

## 🔄 Variable Precedence

Variable precedence is crucial when a variable key exists in multiple scopes. HawkClient resolves variables using the following order of precedence:

1. **Request Variables** – highest priority  
2. **Environment Variables**  
3. **Collection Variables**  
4. **Global Variables** – lowest priority

This means that a variable defined at the request level will always override the same key defined in global or other scopes.
`;

const GlobalVariables = () => {
    return (
        <MarkDownRenderer
            title="Global Variables"
            markDownText={markdownContent}
        />
    );
};

export default GlobalVariables;
